import * as React from 'react';

function SvgShortCircuit(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      data-name="Ebene 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 110.76"
      {...props}
    >
      <path d="M50 25.03a25 25 0 00-25-25 25 25 0 00-25 25v30.53h50z" />
      <path d="M30.63 69.09l5.33-5.74a7.88 7.88 0 002.12-5.4V19.68a2.29 2.29 0 00-2.09-2.31 2.22 2.22 0 00-2.36 2.22v38.36a3.42 3.42 0 01-.9 2.33l-8.21 8.81" />
      <path d="M19.72 69.09l-5.33-5.74a7.88 7.88 0 01-2.11-5.37v-38.3a2.29 2.29 0 012.08-2.31 2.22 2.22 0 012.36 2.22v38.36a3.43 3.43 0 00.91 2.33l8.21 8.81" />
      <path d="M22.36 77.85l8.21-8.76h-6.12l-5.37 5.72a7.88 7.88 0 00-2.11 5.37v9.65c1.42-.5 3.08.88 4.45.39v-10a3.45 3.45 0 01.94-2.37z" />
      <path d="M32.79 91.31v-.13a9.2 9.2 0 00-4.29-1.15 9.2 9.2 0 014.29 1.15V79.62a7.88 7.88 0 00-2.11-5.37l-5.33-5.73h-6.11l8.2 8.79a3.43 3.43 0 01.91 2.33v11.54c1.47.08 3.07-.45 4.44.13z" />
      <path d="M28.35 81.46v26.8a2.23 2.23 0 002.35 2.22 2.29 2.29 0 002.09-2.31V81.58c-1.37-.57-2.97-.04-4.44-.12zM17.01 79.83v28.62a2.28 2.28 0 002.09 2.3 2.22 2.22 0 002.36-2.21V80.21c-1.38.5-3.03-.88-4.45-.38z" />
    </svg>
  );
}

export default SvgShortCircuit;
